import { network } from 'services/network';

import { Report } from 'api/endPoints/getReport';

export const createReportFromTemplate = (params: QueryParams) => {
    const url = `api/bo/reporting/createNewReportFromTemplate`;
    return network.post<QueryResponse>(url, params).then((response) => {
        return response.data;
    });
};

export interface QueryParams {
    templateId: number;
    projectId: number;
    contractId: number;
    name: string;
    selectedTags: number[];
}

export interface QueryResponse {
    report: Report;
}
